import React from 'react';

/**
 * Minimal error fallback for the root error boundary.
 * Does not depend on Router or Redux, so it works even when the error
 * occurs during PersistGate rehydration or before the app tree mounts.
 */
export const RootErrorFallback: React.FC = () => {
  const goToInspections = () => {
    window.location.href = '/inspections';
  };
  const reload = () => {
    window.location.reload();
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
        fontFamily: 'system-ui, sans-serif',
        backgroundColor: '#f5f5f5',
        color: '#333',
      }}
    >
      <h1 style={{ fontSize: '1.5rem', marginBottom: '1rem', textAlign: 'center' }}>
        Something went wrong
      </h1>
      <p style={{ fontSize: '1rem', marginBottom: '1.5rem', textAlign: 'center', maxWidth: '320px' }}>
        Your captured data may still be saved. Go to Inspections to check, or try reloading the page.
      </p>
      <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', justifyContent: 'center' }}>
        <button
          type="button"
          onClick={goToInspections}
          style={{
            padding: '0.75rem 1.5rem',
            fontSize: '1rem',
            fontWeight: 600,
            border: 'none',
            borderRadius: '8px',
            backgroundColor: '#1976d2',
            color: 'white',
            cursor: 'pointer',
          }}
        >
          Go to Inspections
        </button>
        <button
          type="button"
          onClick={reload}
          style={{
            padding: '0.75rem 1.5rem',
            fontSize: '1rem',
            fontWeight: 600,
            border: '1px solid #1976d2',
            borderRadius: '8px',
            backgroundColor: 'white',
            color: '#1976d2',
            cursor: 'pointer',
          }}
        >
          Reload page
        </button>
      </div>
    </div>
  );
};
